import React, { useState } from 'react';
import Layout from '../components/Layout';

function SpareJourney({ user, onLogout }) {
  const [selectedPart, setSelectedPart] = useState('');
  const [partHistory, setPartHistory] = useState([]);

  return (
    <Layout user={user} onLogout={onLogout}>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Spare Journey</h1>
          <p className="text-gray-600 mt-2">Track the complete history of a selected part</p>
        </div>

        {/* Part Selection */}
        <div className="bg-white rounded-lg shadow p-6 mb-6">
          <label className="block text-sm font-medium text-gray-700 mb-2">Select Part Code</label>
          <input
            type="text"
            value={selectedPart}
            onChange={(e) => setSelectedPart(e.target.value)}
            placeholder="Enter part code to track"
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        {/* Journey Timeline */}
        {selectedPart && (
          <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-xl font-semibold mb-6">Journey Timeline for {selectedPart}</h2>
            
            {partHistory.length === 0 ? (
              <p className="text-gray-600 text-center py-8">No history found for this part</p>
            ) : (
              <div className="space-y-4">
                {partHistory.map((event, index) => (
                  <div key={index} className="flex items-start">
                    <div className="flex-shrink-0 w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center">
                      <span className="text-2xl">{event.icon}</span>
                    </div>
                    <div className="ml-4 flex-1">
                      <div className="flex justify-between">
                        <h3 className="font-semibold">{event.title}</h3>
                        <span className="text-sm text-gray-500">{event.date}</span>
                      </div>
                      <p className="text-gray-600 mt-1">{event.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </Layout>
  );
}

export default SpareJourney;
